import ChartBarIcon from "@/assets/icons/chart-bar.svg";
import ChatBubbleIcon from "@/assets/icons/chat-bubble.svg";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import { SearchFiltersFull } from "@/types/SearchFilter";
import AlertShareExportCard from "@components/AlertShareExportCard";
import Modal, { ModalContent, ModalTitle } from "@components/Modal";
import { ModalProps } from "@components/Modal/Modal";

import { Csv, Excel, PowerPoint } from "../AlertShareModal/partials/links";

import styles from "./AlertExportModal.module.css";

const AlertExportModal = ({
  hasPptFeature,
  reportUuid,
  filters,
  ...modalProps
}: ModalProps & {
  hasPptFeature: boolean;
  reportUuid?: string | null;
  filters: Partial<SearchFiltersFull>;
}) => {
  const { alert } = useMentionCards();

  if (!alert) return null;

  return (
    <Modal className={styles.modal} {...modalProps}>
      <ModalTitle>
        {L.EXPORT_ALERT_MODAL_TITLE.replaceAll("{}", alert.title)}
      </ModalTitle>

      <ModalContent>
        <div className={styles.cards}>
          <AlertShareExportCard.Root>
            <AlertShareExportCard.Left>
              <AlertShareExportCard.Icon icon={ChatBubbleIcon} />
              <AlertShareExportCard.LeftText>
                <AlertShareExportCard.Title>
                  {L.EXPORT_ALERT_MODAL_MENTIONS}
                </AlertShareExportCard.Title>
              </AlertShareExportCard.LeftText>
            </AlertShareExportCard.Left>

            <AlertShareExportCard.Right>
              <Excel />
              <Csv />
            </AlertShareExportCard.Right>
          </AlertShareExportCard.Root>

          <AlertShareExportCard.Root>
            <AlertShareExportCard.Left>
              <AlertShareExportCard.Icon color="blue" icon={ChartBarIcon} />
              <AlertShareExportCard.LeftText>
                <AlertShareExportCard.Title>
                  {L.EXPORT_ALERT_MODAL_ANALYTICS}
                </AlertShareExportCard.Title>
              </AlertShareExportCard.LeftText>
            </AlertShareExportCard.Left>

            <AlertShareExportCard.Right>
              <PowerPoint
                filters={filters}
                hasPptFeature={hasPptFeature}
                reportUuid={reportUuid}
              />
            </AlertShareExportCard.Right>
          </AlertShareExportCard.Root>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default AlertExportModal;
